var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle-solid 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2.25C6.60059 2.25 2.25 6.60059 2.25 12C2.25 17.3994 6.60059 21.75 12 21.75C17.3994 21.75 21.75 17.3994 21.75 12C21.75 10.9512 21.6094 9.90527 21.2344 8.92969L20.0156 10.125C20.165 10.7256 20.25 11.3262 20.25 12C20.25 16.5762 16.5762 20.25 12 20.25C7.42383 20.25 3.75 16.5762 3.75 12C3.75 7.42383 7.42383 3.75 12 3.75C14.25 3.75 16.2715 4.64648 17.6953 6.07031L18.75 5.01562C17.0244 3.29004 14.625 2.25 12 2.25ZM20.4609 5.46094L12 13.9219L8.78906 10.7109L7.71094 11.7891L11.4609 15.5391L12 16.0547L12.5391 15.5391L21.5391 6.53906L20.4609 5.46094Z",
    fill: "#008556"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleSolid);
export default __webpack_public_path__ + "static/media/check-circle-solid.8151dcb543cdefc6832345670b4bdf35.svg";
export { ForwardRef as ReactComponent };